import { useIntl } from 'react-intl';
import { BaseIntlProvider } from '@cbhq/identity-shared/web';
import { getClientLocale } from '@cbhq/intl';

const SMARTLING_PROJECT_ID = '5de06f22f';
const SMARTLING_SERVICE_ID = 'identity';

export type IntlWrapperProps = {
  /**
   * Override the locale used for the component. If not provided, the locale will be determined by the user's browser settings.
   */
  overrideLocale?: string;
  children: React.ReactNode;
};

export function IntlWrapper({ overrideLocale, children }: IntlWrapperProps) {
  const { locale: intlLocale } = useIntl();
  const locale = overrideLocale ?? intlLocale ?? getClientLocale();

  return (
    <BaseIntlProvider
      isProd
      locale={locale}
      awaitLoadMessages
      serviceIdentifier={SMARTLING_SERVICE_ID}
      smartlingProjectId={SMARTLING_PROJECT_ID}
    >
      {children}
    </BaseIntlProvider>
  );
}
